export default __webpack_public_path__ + "static/driver-on-mobile-6f0d56d463b4d9627de612ebff49606d.png";